'use client'
import { NewsItem } from '@/app/types/newsType'
import {
  Carousel,
  CarouselApi,
  CarouselContent,
  CarouselItem,
} from '@/components/ui/carousel'
import Autoplay from 'embla-carousel-autoplay'
import Image from 'next/image'
import { useEffect, useState } from 'react'

const NewsImageCarousel = ({ newsDetails }: { newsDetails: NewsItem }) => {
  const [carouselApi, setCarouselApi] = useState<CarouselApi>()
  const [currentCarouselItemIndex, setCurrentCarouselItemIndex] = useState(0)
  const [carouselItemsCount, setCarouselItemsCount] = useState(0)
  const handleCarouselMapperClick = (index: number) => {
    if (!carouselApi) return
    carouselApi.scrollTo(index)
    setCurrentCarouselItemIndex(index)
  }
  useEffect(() => {
    if (!carouselApi) return
    setCarouselItemsCount(carouselApi.scrollSnapList().length)
    carouselApi.on('select', () => {
      setCurrentCarouselItemIndex(carouselApi.selectedScrollSnap())
    })
  }, [carouselApi])
  return (
    <div className="w-full flex justify-center mt-8 mobile:mt-2.5 mobile:justify-start bg-[#f9f9f9] rounded shadow-md">
      {newsDetails && newsDetails?.images?.length > 0 && (
        <div className="flex justify-center w-full cursor-pointer rounded-[3px] overflow-hidden mobile:w-[200px] mobile:h-[200px] ">
          <Carousel
            setApi={setCarouselApi}
            opts={{
              align: 'start',
              loop: true,
            }}
            plugins={[
              Autoplay({
                delay: 10000,
                stopOnInteraction: false,
              }),
            ]}
            className="w-[626px] h-auto mobile:w-[200px] mobile:h-[200px] "
          >
            <CarouselContent className="mx-0 w-full mobile-width">
              {newsDetails?.images?.map((image, index) => (
                <CarouselItem
                  key={index}
                  className="px-0 w-[626px] h-[420px] mobile:w-[200px] mobile:h-[200px]"
                >
                  <a
                    href={
                      image?.redirect_url
                        ? image?.redirect_url.startsWith('http')
                          ? image?.redirect_url
                          : `https://${image?.redirect_url}`
                        : '#'
                    }
                    target="_blank"
                    rel="noopener"
                    onClick={(e) => {
                      if (!image?.redirect_url) {
                        e.preventDefault()
                      }
                    }}
                  >
                    <Image
                      width={626}
                      height={459}
                      src={image.url}
                      alt="News Image"
                      className="w-full h-full object-contain mobile:w-[200px] mobile:h-[200px]"
                    />
                  </a>
                </CarouselItem>
              ))}
            </CarouselContent>
            <div className="flex absolute flex-col left-7 bottom-10">
              <div className="flex items-start gap-[6px]">
                {carouselItemsCount > 1 &&
                  [...Array(carouselItemsCount)].map((_, index) => (
                    <div
                      key={index}
                      className={
                        currentCarouselItemIndex === index
                          ? 'shadow-md w-[12px] h-[12px] bg-sickly_green transition-all ease-in-out delay-150 scale-125 rounded-[10px]'
                          : 'shadow-md w-[12px] h-[12px] bg-[#ffffff] transition-all ease-in-out delay-200 rounded-[10px]'
                      }
                      onClick={() => handleCarouselMapperClick(index)}
                    ></div>
                  ))}
              </div>
            </div>
          </Carousel>
        </div>
      )}
    </div>
  )
}

export default NewsImageCarousel
